/*
 * @Author: shenqian 
 * @Date: 2020.01.08
 */
import JsEncrypt from 'jsencrypt'

export default {
    encrypt: function(str, key, bol) {
        console.log(str, key,bol)
        var jse = new JsEncrypt(),
            result;
        jse.setPublicKey(key);
        result = jse.encrypt(str);
        console.log(encodeURIComponent(jse.encrypt(str)),jse.encrypt(str))
        return bol ? encodeURIComponent(jse.encrypt(str)) : jse.encrypt(str);
    }
}


// WEBPACK FOOTER //
// ./src/components/common/utils/JsEncrypt.js